const config= {
    serveur: window.location.host === "spot.agam.org" || window.location.host === "spot2.agam.org"?
    "/api/"
    :
    "http://agam-srv-bdd1:3000/api/",
    center: [603403.33697965, 5356473.80219608],
    zoom: 11.7,
    couleur_theme3: [238, 228, 44],
    couleur_theme2: [226, 180, 211],
    couleur_theme1: [155, 203, 243],
    couleur_theme23: [233, 78, 27],
    couleur_theme12: [131, 76, 146],
    couleur_theme13: [145, 165, 23],
    couleur_theme123: [0, 0, 0],
    emprisemetropole : [526182.4431257893, 5342238.565661823, 647492.9669, 5427721.790273822],
    emprisedepartement : [470215.7331219694, 5339738.726631183, 648292.0209693555, 5450164.010278303],
    paddingcarte : [20, 20, 20, 20],
}


export default config;